import displayFlash from "partners/scripts/display_flash"
import { patch } from "shared/lib/api"

export default function reviewPipelineActions() {
  document.addEventListener("click", manageAssignments)
}

const manageAssignments = event => {
  if (!event.target.dataset.action) return

  event.preventDefault()

  const btn = event.target
  const data = { service_id: btn.dataset.service }

  if (btn.dataset.action === "add-reviewer") {
    patch(btn.dataset.urlAdd, data)
      .then(data => {
        btn.innerText = `Unassign ${data.username}`
        btn.dataset.action = "remove-reviewer"
        btn.parentNode.previousElementSibling.innerHTML = data.username
      })
      .catch(() => {
        displayFlash("There has been an error adding a reviewer", "error")
      })
  } else if (btn.dataset.action === "remove-reviewer") {
    patch(btn.dataset.urlRemove, data, { Accept: "application/json" })
      .then(() => {
        btn.innerText = "Assign yourself"
        btn.dataset.action = "add-reviewer"
        btn.parentNode.previousElementSibling.innerHTML = "Unassigned"
      })
      .catch(() => {
        displayFlash("There has been an error removing a reviewer", "error")
      })
  }
}
